import React, { Component } from "react";
import TranslationFile from "../../15-Translation/locale/Translation_apps.json";
import { Toast } from "primereact/toast";
import Sidebar from "../SRUSidebar/SRUSidebar";
import Footer_contact_tab from "../../Footerpage/Footer_contact_tab";
import ScrolltoTop from "../../ScrollTop/ScrollTop";
import SRUNavBarHeader from "../SRUNavBarHeader/SRUNavBarHeader";
import { setUserSessionAuthKey } from "../../../Component/commonUtils";
import { Button } from "primereact/button";
import { connect } from "react-redux";
import "./INK2S.css";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from "axios";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import moment from "moment";
import { FcInfo } from "react-icons/fc";
import { Tooltip } from "primereact/tooltip";
import { RadioButton } from "primereact/radiobutton";
import { Helmet } from "react-helmet-async";
import { ProgressSpinner } from "primereact/progressspinner";

let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
let INK2TemplateReqArray = [];
let userSelectedLanguage;
let tabTitleArray = [],
  sruINK2TemplateResponse = {},
  linkSharedUser,
  sruINK2TemplateReqArray = [];
let sruReportHeaderRequestObj = {
    reportGUID: "",
    companyName: "",
    registrationNo: "",
    postalCode: "",
    city: "",
    currentYear: ""
  },
  currentReportGUIDFromUrl,
  selectedForms = [],
  currentPageName = "INK2S";
const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation.values,
    financialYear: state.financialYear.financialYear,
    sessionDetails: state.sessionDetails,
    login: state.login.login.values,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    activeSideBar: state.activeSideBar.activeSideBar,
    incomeStatement: state.incomeStatement.incomeStatement,
    currentPageName: state.currentPageName.currentPageName,
    readOnly: state.readOnly.readOnly,
    showWIPStatus: state.showWIPStatus.showWIPStatus
  };
};

class INK2S extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.inputNumberRef = [];

    this.toast = React.createRef(); // Prevent Undefined Error while click Sidebar

    this.state = {
      activeIndex: [0],
      checked: true,
      checkedNobtn: true,
      checkedYesbtn: false,
      checkedNobtn2: true,
      checkedYesbtn2: false,
      sideBarStatus: true,
      latestCustomLineNo: 0,
      reportGUID: "",
      finalSumLbl: "Årets resultat",
      toggleOpen: false,
      headerCount: 0,
      isLoading: true,
      sruINK2Value: "",
      companyName: "",
      currentFinancialYear: "",
      clickedIndex: null,
      clickedParentIndex: null,
      columnIndex: null,
      currentYear: "",
      currentFromDate: "",
      currentToDate: "",
      fiscalYearPortion: "",
      booleanOptions: [
        { name: "Yes", key: "true" },
        { name: "No", key: "false" }
      ],
      booleanOptions2: [
        { name: "Yes", key: "true" },
        { name: "No", key: "false" }
      ],
      booleanOptions3: [
        { name: "Yes", key: "true" },
        { name: "No", key: "false" }
      ],
      selectedBooleanOptions: { name: "Yes", key: "true" },
      selectedBooleanOptions2: { name: "Yes", key: "true" },
      selectedBooleanOptions3: { name: "Yes", key: "true" }
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleChange(toggleOpen) {
    window.scroll(0, 0);
    if (toggleOpen == true) {
      let headerIdxList = [];
      Object.keys(tabTitleArray).map((heading, idx) => {
        headerIdxList.push(idx);
      });
      this.setState({ activeIndex: headerIdxList });
      this.setState({ toggleOpen: false });
    } else {
      let collapse = [];
      this.setState({ activeIndex: collapse });
      this.setState({ toggleOpen: true });
    }
  }

  openAll(resp) {
    let headerIdxList = [];
    Object.keys(resp).map((heading, idx) => {
      headerIdxList.push(idx);
    });
    let open = headerIdxList;
    this.setState({ activeIndex: open });
  }

  convert = (str) =>
    str.split(",").flatMap((s) => {
      console.log("Value Converted", str, "New Converter", s);
      if (!s.includes("-")) return +s;
      const [min, max] = s.split("-");
      return Array.from({ length: max - min + 1 }, (_, n) => n + +min);
    });

  handleClickOutside(event) {
    let index = this.state.clickedIndex;
    let inputReference = this.inputNumberRef[index];
    if (this.state.clickedIndex !== null && inputReference) {
      this.setState({ clickedIndex: null });
    }
  }

  sanitizeFinancialValue(value) {
    // NULL / undefined
    if (value === null || value === undefined) {
      return "";
    }

    let cleaned = String(value)
      .trim()

      // Remove all spaces
      .replace(/\s/g, "")

      // Normalize all unicode minus chars
      .replace(/[‐-‒–—−]/g, "-");

    // Empty
    if (cleaned === "") {
      return "";
    }

    // Remove thousand separators
    cleaned = cleaned.replace(/,/g, "");

    let parsed = Number(cleaned);

    // Invalid number
    if (isNaN(parsed)) {
      console.error("Invalid Financial Value From DB/API", {
        originalValue: value,
        cleanedValue: cleaned
      });

      return 0;
    }

    // Round decimals
    return Math.round(parsed);
  }

  normalizeBooleanValue(value) {
    if (value === true || value === "true" || value === 1 || value === "1") {
      return "true";
    }

    if (value === false || value === "false" || value === 0 || value === "0") {
      return "false";
    }

    return value;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentWillMount() {
    let { currentFromDate, currentToDate } = this.state;
    window.scrollTo(0, 0);
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    let { sideBarReducer, currentPageName, companyInformation } = this.props;
    currentPageName.values = "INK2S";
    localStorage.setItem("currentPageName", "INK2S");

    let splittedUrl = window.location.href.split("/");
    currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];

    sruReportHeaderRequestObj.reportGUID = currentReportGUIDFromUrl;

    if (userSessionAuthKeyReturnValue) {
      sruINK2TemplateReqArray = [];
      axios
        .get(
          "/SRUHeader/getHeader?reportGuid=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data.forms != "" && response.data.forms != null) {
            selectedForms = response.data.forms.split(",");
          }

          let companyName = response.data.companyName;
          let registrationNo = response.data.registrationNo;
          let currentYear = response.data.currentYear;
          let splittedCurrentYear = currentYear.split(" - ");
          let currentStartingPeriod = splittedCurrentYear[0];
          let currentEndingPeriod = splittedCurrentYear[1];
          let sruTemplateReq = {
            validFromDate: currentStartingPeriod,
            validToDate: currentEndingPeriod,
            statementType: 3
          };
          sruINK2TemplateReqArray.push(sruTemplateReq);

          this.setState({
            companyName: companyName,
            registrationNo: registrationNo,
            currentYear: currentYear,
            currentFromDate: currentStartingPeriod,
            currentToDate: currentEndingPeriod,
            fiscalYearPortion: response.data.fiscalYearPortion,
            loading: false
          });

          let responseDate = response.data;
          if (responseDate != "" && null != responseDate.reportID) {
            let reportAccessReq = { reportId: responseDate.reportID };

            axios
              .post(
                "/SRUHeader/getAccessStatus",
                reportAccessReq,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                switch (response.data) {
                  case 2:
                    linkSharedUser = 2; //Write
                    break;
                  case 3:
                    linkSharedUser = 3; //Read Only
                    break;
                  case 4:
                    linkSharedUser = 4; //No Access
                    break;
                }
                if (responseDate.companyName != "") {
                  this.setState({
                    companyName: responseDate.companyName
                  });
                }
                if (responseDate.currentYear != "")
                  this.setState({
                    currentFinancialYear: responseDate.currentYear
                  });
              })

              .catch((error) => {
                let noAccessURL =
                  "/income-declaration-2/" +
                  currentReportGUIDFromUrl +
                  "/no-access";
                this.props.history.push(noAccessURL);
              });

            axios
              .get(
                "/SRU/getCompletedPages?reportId=" + responseDate.reportID,
                userSessionAuthKeyReturnValue
              )
              .then((response2) => {
                sideBarReducer.values = response2.data;

                sideBarReducer.values.push("My Dashboard");
                sideBarReducer.values.push("Company Information");

                let getPossibleAccessablePages = localStorage.getItem(
                  "sruPossibleAccessablePages"
                );
                let getPossibleAccessablePagesArray = JSON.parse(
                  getPossibleAccessablePages
                );
                getPossibleAccessablePagesArray.push("INK2S");

                sideBarReducer.values.push("INK2S");
                let updatePossibleNavigationPagesListString = JSON.stringify(
                  getPossibleAccessablePagesArray
                );
                localStorage.setItem(
                  "sruPossibleAccessablePages",
                  updatePossibleNavigationPagesListString
                );
              });
          }

          let getJsonLines = {
            guid: currentReportGUIDFromUrl,
            pageName: "INK2S"
          };

          axios
            .post(
              "/SRULines/getLinesJson",
              getJsonLines,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              let responseData = response.data.ink2S;
              if (responseData == undefined) {
                responseData = "";
              }

              if (responseData != "") {
                let jsonConvertedResponseData = JSON.parse(responseData);

                Object.keys(jsonConvertedResponseData).forEach((heading) => {
                  if (heading !== "financialYear") {
                    jsonConvertedResponseData[heading].forEach((item) => {
                      if (
                        item.currentYearValue !== undefined &&
                        item.currentYearValue !== null &&
                        item.currentYearValue !== ""
                      ) {
                        if (item.valueType === "Yes/No") {
                          item.currentYearValue = this.normalizeBooleanValue(
                            item.currentYearValue
                          );
                        } else {
                          // Only sanitize numeric fields
                          item.currentYearValue = this.sanitizeFinancialValue(
                            item.currentYearValue
                          );
                        }
                      }
                    });
                  }
                });

                let financialYearFromJsonResponse = [];
                Object.keys(jsonConvertedResponseData).map((i, idx) => {
                  if (i == "financialYear") {
                    financialYearFromJsonResponse = [
                      ...jsonConvertedResponseData[i]
                    ];
                  }
                  console.log(jsonConvertedResponseData, "Satya");
                });

                INK2TemplateReqArray = financialYearFromJsonResponse;

                delete jsonConvertedResponseData.financialYear;

                tabTitleArray = jsonConvertedResponseData;
                this.openAll(jsonConvertedResponseData);

                this.setState({
                  sruINK2Value: jsonConvertedResponseData,
                  isLoading: false
                });
              } else {
                if (userSessionAuthKeyReturnValue) {
                  INK2TemplateReqArray = [];
                  companyInformation != undefined &&
                    companyInformation.financialYear.length &&
                    companyInformation.financialYear.map(
                      (financialYear, idx) => {
                        let INK2TemplateReq = {
                          validFromDate: moment(financialYear.from).format(
                            "YYYY-MM-DD"
                          ),
                          validToDate: moment(financialYear.to).format(
                            "YYYY-MM-DD"
                          ),
                          statementType: 3
                        };
                        INK2TemplateReqArray.push(INK2TemplateReq);
                      }
                    );

                  if (sruINK2TemplateReqArray.length > 0) {
                    axios
                      .post(
                        "/SRUHeader/getSRUTemplateLinesByFY",
                        sruINK2TemplateReqArray,
                        userSessionAuthKeyReturnValue
                      )
                      .then((Response) => {
                        sruINK2TemplateResponse = Response.data;
                        this.dataManipulation(
                          sruINK2TemplateResponse,
                          true,
                          false
                        );

                        tabTitleArray = sruINK2TemplateResponse;
                        this.openAll(sruINK2TemplateResponse);
                      });
                  }
                }
              }
            });
        });
    }
  }

  dataManipulation(resp, isInitialRender, isOnChangeCall) {
    let { sruINK2Value } = this.state;
    if (isInitialRender) {
      Object.keys(resp).map((i, idx) => {
        let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
      });
      this.setState({
        sruINK2Value: resp
      });
      this.updateLinesTable(resp);
      this.insertUpdateJSONLines();
    }
  }

  updateLinesTable(resp) {
    let fieldExistsInMultiYear = [],
      lineNoArray = [],
      lineDetailsArray = [];
    Object.keys(resp).map((i, idx) => {
      let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
      sortedRespArray.map((sortedResp, sortedRespIdx) => {
        sortedResp["currentYearValue"] = sortedResp.currentYearValue;
        sortedResp["reportGUID"] = currentReportGUIDFromUrl;
        sortedResp["mapToAccountNos"] = sortedResp.mapToAccountNos;
      });
    });

    // calculating lineAmount
    let number = 0,
      operator = "";
    Object.keys(resp).map((i, idx) => {
      let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
      sortedRespArray.map((sortedResp, sortedRespIdx) => {
        if (
          sortedResp.valueType != "" &&
          sortedResp.currentYearValue != undefined
        ) {
          switch (sortedResp.valueType) {
            case "Positive":
              operator = "+";
              break;
            case "Negative":
              operator = "-";
              break;

            default:
              operator = "+";
              break;
          }
          // number = number + operator+ sortedResp.currentYearValue
          number =
            operator === "+"
              ? number + sortedResp.currentYearValue
              : number - sortedResp.currentYearValue;

          if (number > 0) {
            if (sortedResp.lineNo == 14400) {
              sortedResp.currentYearValue = number;
            }
          } else {
            if (sortedResp.lineNo == 14500) {
              sortedResp.currentYearValue = number;
            }
          }
        }
      });
    });

    Object.keys(resp).map((i, idx) => {
      let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
      sortedRespArray.map((sortedResp, sortedRespIdx) => {
        const filtered = sortedRespArray.filter(
          (obj) => obj.lineNo == sortedResp.lineNo
        );
        fieldExistsInMultiYear.push(Object.assign({}, ...filtered));
      });
    });

    fieldExistsInMultiYear.length &&
      fieldExistsInMultiYear.map((i, idx) => {
        if (!lineNoArray.includes(i.lineNo)) {
          lineNoArray.push(i.lineNo);
          lineDetailsArray.push(i);
        }
      });
    if (lineDetailsArray.length > 0) {
      axios
        .post(
          "/SRULines/insertAndUpdateLines",
          lineDetailsArray,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {})
        .catch((error) => {});
      this.setState({
        sruINK2Value: resp
      });
    }
  }
  insertUpdateJSONLines() {
    const { sruINK2Value } = this.state;
    let responseJson = sruINK2Value;
    if (responseJson != "") {
      let updateJsonTableObj = {
        pageName: "INK2S",
        guid: currentReportGUIDFromUrl,
        json: JSON.stringify(responseJson)
      };
      axios
        .post(
          "/SRULines/insertAndUpdateLinesJsonTable",
          updateJsonTableObj,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {});
    }
  }

  AmountOnBlur(e, num, heading, field) {
    console.log("e", e);
    console.log("num", num);
    console.log("heading", heading);
    console.log("field", field);
    const { sruINK2Value } = this.state;
    let custEnteredValue = e.target.value;

    // Find current item and keep the previous value
    const currentItem = sruINK2Value[heading].find(
      (i) => i.lineNo == num.lineNo
    );

    if (!currentItem) {
      return;
    }

    const previousValue = String(currentItem.currentYearValue ?? "");

    const enteredValue = String(custEnteredValue ?? "")
      .replace(/[\s\u00A0\u202F]/g, "")
      .replace(/−/g, "-");

    if (previousValue === enteredValue) {
      console.log("Value unchanged. API call skipped.");
      return;
    }

    sruINK2Value[heading].map((i, idx) => {
      if (i.lineNo == num.lineNo) {
        // NUMBER FIELD
        if (field == "Number") {
          let spacesRemoved = String(custEnteredValue || "")
            .replaceAll(/\s/g, "")
            .replace(/−/g, "-");

          // Empty value handling
          if (spacesRemoved === "") {
            // i["currentYearValue"] = "";
            delete i.currentYearValue;
          } else if (spacesRemoved === "0") {
            i["currentYearValue"] = spacesRemoved;
          } else {
            let parsedValue = Number(spacesRemoved);

            // Invalid number handling
            if (isNaN(parsedValue)) {
              console.error("Invalid Number Detected", {
                object: i,
                enteredValue: custEnteredValue,
                processedValue: spacesRemoved,
                heading: heading,
                lineNo: i.lineNo
              });

              parsedValue = 0;
            }

            // -------------
            // console.log("parsedValue", parsedValue);

            // if (i.valueType == "Positive") {
            //   console.log("new positive object", i.valueType);
            //   parsedValue = Math.round(parsedValue);
            // } else if (i.valueType == "Negative") {
            //   console.log("new negative object before conversion", parsedValue);
            //   parsedValue = -1 * Math.round(parsedValue);
            //   console.log("new negative object after conversion", parsedValue);
            // }
            // --------------
            // Round decimal values
            // parsedValue = Math.round(parsedValue);

            // const value = e?.target?.value ?? "";

            // console.log("before trim value", value);
            // if (value.trim() !== "") {
            //   console.log("keepValue", value);
            //   i.currentYearValue = parsedValue;
            // } else {
            //   console.log("deleteEmptyValue", value);
            //   delete i.currentYearValue;
            // }

            i["currentYearValue"] = parsedValue;
          }
        }

        // TEXT FIELD
        else if (field == "Text") {
          i["currentYearValue"] = custEnteredValue;
        } else if (field == "Boolean") {
          // custEnteredValue = e.checked;
          custEnteredValue = e.value;
          console.log("e.target.value.key", custEnteredValue);
          console.log("Boolean Option", e.checked);
          console.log(
            "Customer Entered Value",
            custEnteredValue,
            typeof custEnteredValue
          );
          // this.setState({
          //   selectedBooleanOptions: e.value,
          // });
          i["currentYearValue"] = custEnteredValue;
        }
      }
    });

    // Keep existing architecture
    this.setState({
      sruINK2Value: ""
    });

    let lineSumFilter = [];
    let valueTypeFilter = [];

    sruINK2Value[heading].map((i, idx) => {
      if (i.lineType == "Line Sum") {
        lineSumFilter.push(i);
      }

      if (
        (i.valueType == "Positive" || i.valueType == "Negative") &&
        i.lineType !== "Line Sum"
      ) {
        valueTypeFilter.push(i);
      }
    });

    let lineSum = 0;
    let lineValue = 0;

    valueTypeFilter &&
      valueTypeFilter.map((val) => {
        // Prevent NaN propagation
        if (
          val.currentYearValue !== "" &&
          val.currentYearValue !== undefined &&
          !isNaN(Number(val.currentYearValue))
        ) {
          console.log(
            "lineNo",
            val.lineNo,
            "valueTypeFilter",
            val.currentYearValue
          );

          console.log("val.currentYearValue", val.currentYearValue);

          if (val.valueType == "Positive") {
            console.log("new positive object", val.valueType);
            val.currentYearValue = Math.round(val.currentYearValue);
            lineValue = val.currentYearValue;
          } else if (val.valueType == "Negative") {
            // if (!String(parsedValue).startsWith("-")) {
            //   console.log("parsed valued not start with -", parsedValue);
            // } else {
            // console.log("new negative object before conversion", parsedValue);
            lineValue = -1 * Math.round(val.currentYearValue);
            // console.log("new negative object after conversion", parsedValue);
          }

          lineSum = lineSum + Number(lineValue);
        }
      });

    if (lineSumFilter.length > 0) {
      sruINK2Value[heading].map(() => {
        const isPositive = lineSum > 0;

        lineSumFilter.find((val) => val.valueType === "Positive")[
          "currentYearValue"
        ] = isPositive ? lineSum : 0;

        lineSumFilter.find((val) => val.valueType === "Negative")[
          "currentYearValue"
        ] = isPositive ? 0 : Math.abs(lineSum);
      });
    }

    // if (lineSumFilter.length > 0) {
    //   sruINK2Value[heading].map(() => {
    //     const isPositive = lineSum > 0;

    //     console.log("123>>>", sruINK2Value);

    //     const positive = lineSumFilter.find(
    //       (val) => val.valueType === "Positive"
    //     );
    //     if (positive) {
    //       positive["currentYearValue"] = isPositive ? lineSum : 0;
    //     }

    //     const negative = lineSumFilter.find(
    //       (val) => val.valueType === "Negative"
    //     );
    //     if (negative) {
    //       negative["currentYearValue"] = isPositive ? 0 : Math.abs(lineSum);
    //     }
    //   });
    // }

    this.updateLinesTable(sruINK2Value);

    this.insertUpdateJSONLines();
  }

  callback = (incomedeclaration2SRU, session, link, status) => {
    const { sessionDetails } = this.props;
    let sessionFromLS = localStorage.getItem("sessionUUID");
    if (status) {
      this.props.history.push(incomedeclaration2SRU + sessionFromLS + link);
    }
    this.setState({
      reRender: true
    });
  };
  navigateToNextPages(side) {
    const { sessionDetails } = this.props;
    let uuid = sessionDetails.sessionDetails.values.uuid;
    let index = selectedForms.indexOf(currentPageName);

    if (side == "next") {
      // Go To Next Page
      let nextPageName = selectedForms[index + 1];

      // If next page exists
      if (nextPageName != "" && nextPageName != undefined) {
        // Go To INK2R / INK2S
        this.props.history.push(
          "/income-declaration-2/" + uuid + "/" + nextPageName
        );
      } else {
        // No next form
        // Go To reviewAndSend
        const user = JSON.parse(localStorage.getItem("rebelSkoolUser") || "{}");
        if (!user?.emailID) {
          // this.props.history.push("/income-declaration-2");
          this.toast.current?.show({
            severity: "info",
            summary: "Info",
            detail:
              TranslationFile.pleaseLoginToProceedFurther[userSelectedLanguage],
            life: 5000
          });
          document.getElementsByClassName("user-btn")[0]?.click();
          return;
          console.log("User not logged in. Redirecting to /companyInfo");
          // window.location.reload();
        }

        const userEmail = JSON.parse(
          localStorage.getItem("rebelSkoolUser")
        )?.emailID;

        if (!userEmail) {
          document.getElementsByClassName("user-btn")[0].click();
          return;
          // history.push(selectedSideMenu);
        }

        this.props.history.push(
          "/income-declaration-2/" + uuid + "/reviewAndSend"
        );
      }
    } else {
      // Go To Previous Page
      let previousPageName = selectedForms[index - 1];

      if (previousPageName == undefined) {
        // Go To Company Info Page
        this.props.history.push(
          "/income-declaration-2/" + uuid + "/companyInfo"
        );
      } else {
        this.props.history.push(
          "/income-declaration-2/" + uuid + "/" + previousPageName
        );
      }
    }
  }

  sideBarStatus = (e) => {
    this.setState({
      sideBarStatus: e
    });
  };

  sideBarCallback = (value) => {
    if (value) {
      this.toast.current?.show({
        severity: "info",
        summary: "Info",
        detail: TranslationFile.CompleteCurrentPageText[userSelectedLanguage],
        life: 5000
      });
      this.setState({
        reRender: true
      });
    }
  };

  accordionHeader(header) {
    return (
      <Row>
        <Col
          xs={5}
          sm={5}
          md={5}
          lg={5}
          xl={5}
          style={{ width: "41%", marginTop: "7px", marginLeft: "2%" }}
        >
          <label
            className="SRU-INK2SFieldsStyle"
            style={{ marginLeft: "-21px" }}
          >
            {header}
          </label>
        </Col>
      </Row>
    );
  }

  setClickedIndex(idx, parentIdx, number) {
    this.setState((prevState) => ({
      clickedIndex: prevState.clickedIndex === idx ? null : idx
    }));
    this.setState({
      // clickedIndex: idx,
      clickedParentIndex: parentIdx,
      columnIndex: number
    });
  }

  setRef = (index) => (el) => {
    this.inputNumberRef[index] = el;
  };

  render() {
    const {
      sideBarStatus,
      toggleOpen,
      activeIndex,
      sruINK2Value,
      companyName,
      registrationNo,
      clickedIndex,
      clickedParentIndex,
      columnIndex,
      fiscalYearPortion,
      booleanOptions,
      booleanOptions2,
      booleanOptions3,
      selectedBooleanOptions,
      selectedBooleanOptions2,
      selectedBooleanOptions3,
      isLoading
    } = this.state;
    let { showWIPStatus } = this.props;
    let pageUnderWIP = false;
    if (showWIPStatus.values != undefined) {
      if (showWIPStatus.values) {
        pageUnderWIP = true;
      } else {
        pageUnderWIP = false;
      }
    }
    return (
      <div className="SRU-INK2S">
        {/* <Toast
          ref={(el) => {
            this.toast = el;
          }}
          className="SRU-companyInfoErrorToast"
          style={{ marginTop: "34%" }}
        ></Toast> */}
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <SRUNavBarHeader
          callBack={this.callback}
          isAppPortal={true}
          isHomePage={false}
        />

        <div
          className={
            pageUnderWIP
              ? "SRU-companyInfoSideBarWithWIP"
              : "SRU-companyInfoSideBar"
          }
        >
          <Toast ref={this.toast} />

          <Sidebar
            children="INK2S"
            sideBarStatus={this.sideBarStatus.bind(this)}
            sideBarCallback={this.sideBarCallback.bind(this)}
          />
        </div>

        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "50vh",
              flexDirection: "column"
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="8"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <>
            <div>
              <Row
                className={
                  sideBarStatus
                    ? "SRU-INK2SFYStyle"
                    : "SRU-INK2SFYStyle-sidebar-close"
                }
              >
                <div className="SRU-INK2Sparent">
                  <Col>
                    <div className="SRU-Page_Title_INK2">
                      <div className="SRU-Page_Title_T1_INK2S">
                        {this.state.companyName} ({this.state.registrationNo})
                        <div className="SRU-INK2SFYMainDiv">
                          {fiscalYearPortion}
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>
              </Row>
            </div>
            <div
              className={
                sideBarStatus ? "SRU-INK2SSideBarOpen" : "SRU-INK2SSideBarClose"
              }
            >
              <div>
                <Row className="SRU-INK2SParentRow">
                  <Col
                    style={{
                      width: "100%"
                    }}
                  >
                    {sruINK2Value != undefined && (
                      <div className="INK2S-main-grid">
                        {Object.keys(sruINK2Value).map((heading, parentIdx) => {
                          let responseArray = [...sruINK2Value[heading]].sort(
                            (a, b) => a.lineNo - b.lineNo
                          );

                          let header = responseArray[0].name;

                          let rows = responseArray.filter(
                            (num) => num.lineNo !== responseArray[0].lineNo
                          );

                          return (
                            <div className="INK2S-section-card" key={parentIdx}>
                              <div className="INK2S-section-header">
                                {header}
                              </div>

                              <div className="INK2S-table">
                                {rows.map((num, idx) => {
                                  if (
                                    num.lineType === "Header" &&
                                    num.lineLevel > 1
                                  ) {
                                    return (
                                      <div
                                        className="INK2S-subheader-row"
                                        key={idx}
                                      >
                                        <div
                                          className="INK2S-subheader-label"
                                          style={{
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            paddingTop: "10px",
                                            paddingLeft: "10px",
                                            textDecoration: "underline"
                                          }}
                                        >
                                          {num.name}
                                        </div>
                                      </div>
                                    );
                                  }

                                  return (
                                    <div className="INK2S-row" key={idx}>
                                      <div className="INK2S-label">
                                        <span className="serial">
                                          {num.serialNumber}
                                        </span>
                                        <Tooltip
                                          target=".name"
                                          position="top"
                                          pt={{
                                            root: {
                                              style: {
                                                boxShadow: "none",
                                                filter: "none"
                                              }
                                            },
                                            token: {
                                              style: { boxShadow: "none" }
                                            } // Clears inner shadow tokens if any
                                          }}
                                        />
                                        <span
                                          className="name"
                                          data-pr-tooltip={num.mapToAccountNos}
                                        >
                                          {num.name}
                                        </span>
                                      </div>
                                      {num.valueType !== "Yes/No" ? (
                                        <div className="INK2S-input">
                                          {num.lineLevel > 2 && (
                                            <InputNumber
                                              value={
                                                num.currentYearValue === ""
                                                  ? null
                                                  : num.currentYearValue
                                              }
                                              className={
                                                num.lineType == "Line Sum" &&
                                                "SRU-ISAmountBoxDisabled"
                                              }
                                              // placeholder="0"
                                              mode="decimal"
                                              // onValueChange={(e) => {
                                              //   const { sruINK2Value } = this.state;

                                              //   sruINK2Value[heading].forEach(
                                              //     (item) => {
                                              //       if (
                                              //         item.lineNo === num.lineNo
                                              //       ) {
                                              //         item.currentYearValue =
                                              //           e.value;
                                              //       }
                                              //     }
                                              //   );

                                              //   this.setState({
                                              //     sruINK2Value
                                              //   });
                                              // }}
                                              onBlur={(e) => {
                                                this.AmountOnBlur(
                                                  e,
                                                  num,
                                                  heading,
                                                  "Number"
                                                );
                                              }}
                                              ref={this.setRef(idx)}
                                              // onMouseDown={(e) => e.preventDefault()}
                                              onClick={() =>
                                                this.setClickedIndex(
                                                  idx,
                                                  parentIdx,
                                                  2
                                                )
                                              }
                                              locale="sv-SE"
                                              style={{
                                                textAlignLast: "right"
                                              }}
                                              showButtons={
                                                num.valueType != "" && true
                                              }
                                              step={0}
                                              buttonLayout="horizontal"
                                              buttonSize="large"
                                              inputId="horizontal-buttons"
                                              decrementButtonClassName="value-type-button"
                                              incrementButtonClassName="value-type-hidden-button" // Hide the plus button
                                              decrementButtonIcon={
                                                num.lineType === "Line Sum"
                                                  ? "pi pi-equals"
                                                  : num.valueType
                                                    ? num.valueType ===
                                                      "Positive"
                                                      ? "pi pi-plus"
                                                      : "pi pi-minus"
                                                    : ""
                                              }
                                              decrementButtonProps={{
                                                disabled: true
                                              }}
                                              disabled={
                                                (num.lineType == "Line Sum" &&
                                                  true) ||
                                                linkSharedUser == 3
                                              }
                                            />
                                          )}
                                        </div>
                                      ) : (
                                        <div className="checkbox-container">
                                          {booleanOptions.map((options) => (
                                            <div
                                              className="checkbox-item"
                                              key={options.key}
                                            >
                                              <RadioButton
                                                inputId={`${num.lineNo}-${options.key}`}
                                                name={`options-${num.lineNo}`}
                                                value={options.key}
                                                disabled={linkSharedUser == 3}
                                                onChange={(e) => {
                                                  // num.currentYearValue = String(
                                                  //   e.value
                                                  // );
                                                  this.setState(
                                                    // {
                                                    //   sruINK2Value: {
                                                    //     ...this.state
                                                    //       .sruINK2Value
                                                    //   }
                                                    // },
                                                    () => {
                                                      this.AmountOnBlur(
                                                        e,
                                                        num,
                                                        heading,
                                                        "Boolean"
                                                      );
                                                    }
                                                  );
                                                }}
                                                checked={
                                                  String(
                                                    num.currentYearValue
                                                  ) === options.key
                                                }
                                              />

                                              <label
                                                htmlFor={`${num.lineNo}-${options.key}`}
                                                className="ink2s-options-label"
                                              >
                                                {options.name}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
              <center className="SRU-INK2S-btn-center">
                <Button
                  label="Previous"
                  aria-label="year-btn-save"
                  onClick={() => this.navigateToNextPages("previous")}
                  style={{
                    marginTop: "2%",
                    marginRight: "1%"
                  }}
                  // className="ISSaveBtn"
                  className="SRU-year-btn-save"
                />
                <Button
                  label="Next"
                  aria-label="year-btn-save"
                  onClick={() => this.navigateToNextPages("next")}
                  style={{
                    marginTop: "2%"
                  }}
                  // className="ISSaveBtn"
                  className="SRU-year-btn-save"
                />
              </center>
              <br></br>
              <br></br>
            </div>
          </>
        )}
        <ScrolltoTop />
        <Footer_contact_tab
          sideBar={this.state.sideBarStatus}
          isCorpPortal={false}
          isHomePage={true}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(INK2S);
